import { formatHours } from "@/lib/format";

interface CloseMonthStatsProps {
  loggedHours: number;
  capacity: number;
  absenceHours: number;
  billingRate: number | null;
}

export default function CloseMonthStats({
  loggedHours,
  capacity,
  absenceHours,
  billingRate,
}: CloseMonthStatsProps) {
  const rateColor =
    billingRate === null
      ? "text-muted-foreground"
      : billingRate >= 65
        ? "text-emerald-600"
        : billingRate >= 50
          ? "text-amber-600"
          : "text-destructive";

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div className="p-4 rounded-lg border border-border/50 bg-card">
        <p className="text-xs text-muted-foreground mb-1">Loggede timer</p>
        <p className="text-xl font-bold">{formatHours(loggedHours)}</p>
      </div>
      <div className="p-4 rounded-lg border border-border/50 bg-card">
        <p className="text-xs text-muted-foreground mb-1">Kapasitet</p>
        <p className="text-xl font-bold">{formatHours(capacity)}</p>
      </div>
      <div className="p-4 rounded-lg border border-border/50 bg-card">
        <p className="text-xs text-muted-foreground mb-1">Fravær</p>
        <p className="text-xl font-bold">{formatHours(absenceHours)}</p>
      </div>
      <div className="p-4 rounded-lg border border-border/50 bg-card">
        <p className="text-xs text-muted-foreground mb-1">Faktureringsgrad</p>
        <p className={`text-xl font-bold ${rateColor}`}>
          {billingRate !== null ? `${billingRate}%` : "—"}
        </p>
      </div>
    </div>
  );
}
